
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"5","viewBox":"0 0 19.5 5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.7727 0.863663H1.22728C0.549817 0.863663 0 1.41348 0 2.09094V2.90907C0 3.58653 0.549817 4.13635 1.22728 4.13635H16.7727C17.4502 4.13635 18 3.58653 18 2.90907V2.09094C18 1.41348 17.4502 0.863663 16.7727 0.863663Z"}})])
          )
        }
      }
    